(() => {
    document.addEventListener('DOMContentLoaded', function () {

        const search = document.getElementsByClassName('search-field');
        if (!search || search.length != 1) {
            return;
		}

		let fileInput = document.getElementById('asfinputFile');
		fileInput.addEventListener('change', fileSelected);

		let submitButton = document.getElementById('asfSubmit');
		submitButton.disabled = true;

		function fileSelected(evt) {
			let submitButton = document.getElementById('asfSubmit');
			if (evt.target.files.length > 0) 
				submitButton.disabled = false;
			else
                submitButton.disabled = true;
		}

		function searchPreviousSessions(pageNumber) {
			let path = `/App/PreviousSessions?pageNumber=${pageNumber}`;

			let searchTermTextBox = document.getElementById('searchTermTB');
			if (searchTermTextBox && searchTermTextBox.value && searchTermTextBox.value.length > 0)
				path += `&searchTerm=${searchTermTextBox.value}`;

			window.location = path;
		}
		function resetSearchPreviousSessions() {
			let searchTermTextBox = document.getElementById('searchTermTB');
			if (searchTermTextBox) {
				searchTermTextBox.value = '';
			}
		}
		function addFileToSession(sessionGuid) {
			let sessionGuidCtl = document.getElementById('asfsessionGuid');
			sessionGuidCtl.value = sessionGuid;
			let fileInput = document.getElementById('asfinputFile');
			fileInput.value = null;

			let validation = document.getElementById('asfvalidation');
			validation.innerHTML = '';

		}
		function submitAddSessionFile() {
			let sessionGuid = document.getElementById('asfsessionGuid');
			let fileInput = document.getElementById('asfinputFile');
			let validation = document.getElementById('asfvalidation');
			if (fileInput.files.length > 0) {
				let formData = new FormData();
				formData.append('File', fileInput.files[0]);
				formData.append('SessionGuid', sessionGuid.value);
				fetch('/App/AttachFileToPreviousSession', {
					method: 'POST',
					body: formData
				})
					.then(response => response.json())
					.then(data => {
						if (data.success) {
							console.log('file upload success');
							// reload view
							window.location.reload();
						}
						else {
							console.log('Error adding file: ' + data.message);
						}
						
						let addSessionFileModal = document.getElementById('addSessionFileModal');
                        addSessionFileModal.style.display = 'none';


					})
					.catch(error => { console.error('Error:', error); $('#addSessionFileModal').modal('hide'); });
			}
			else {
				validation.innerHTML = 'Please select a file to upload.';
			}
		}


		window.searchPreviousSessions = searchPreviousSessions;
		window.resetSearchPreviousSessions = resetSearchPreviousSessions;
		window.addFileToSession = addFileToSession;
		window.submitAddSessionFile = submitAddSessionFile;

    });
})();
